module.exports = __webpack_public_path__ + "8e5c020574645cc49042df221f917165.png";